import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { WIZ_EVENT_TYPE, CONFIRMATION_MODE, CONFIRMATION_RESULT } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  IWizRoute,
  WizActionObj,
  WizDatasource,
  WizNavigationManager,
  WizPopUp,
  WizRoot,
  WizTabBar,
  WizTabButton,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { distinctUntilChanged, filter, first, map, Subject, takeUntil } from 'rxjs';
import { ALK_EVENT_TYPE, BaseView, TabVO } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { UserContextService } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { UserTabView } from './../../user-tab/user-tab.view';
import { Model } from 'src/app/model/model';
import { RouteEngine } from 'src/app/manager/routing/route.engine';

@Component({
  selector: 'tab-bar',
  templateUrl: './tab.bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabBar implements OnInit, AfterViewInit, OnDestroy {
  /** Tab bar */
  @ViewChild('tabBar', { read: WizTabBar, static: true }) tabBar: WizTabBar;

  public tabs: WizDatasource<WizActionObj> = new WizDatasource<WizActionObj>().build(); // la DS de la Tabbar

  private _destroyed$: Subject<boolean> = new Subject<boolean>();

  /**
   * Le chemin sur lequel on se trouve
   */
  private _currentTab: string;

  constructor(
    private router: Router,
    private _changedDetectorRef: ChangeDetectorRef
  ) {}

  private get _context(): UserContextService {
    return Model.getInstance().userContextService;
  }

  ngOnInit(): void {
    this.drawTabs(); // création des tabs du user

    // Initialisation du selectedTab selon les données du contexte utilisateur
    this._onTabChanged(this._context.getCurrentTab()?.selectedTab, false);

    this.router.events
      .pipe(
        filter((event) => event instanceof ActivationEnd),
        map((event: ActivationEnd) => ({ event, wizroute: event.snapshot.routeConfig as IWizRoute })),
        filter(({ event, wizroute }) => {
          return !!event.snapshot.params?.code || !!wizroute?.featureCode || !!wizroute?.fullPath;
        }),
        map(({ event, wizroute }) => event.snapshot.params.code || wizroute.featureCode || wizroute.fullPath),
        distinctUntilChanged(),
        filter((tabCode) => tabCode !== this._context.getCurrentTab()?.selectedTab),
        takeUntil(this._destroyed$)
      )
      .subscribe((tab) => this._onTabChanged(tab));

    // Ecoute du chargement de contexte de nouvelles visions, pour update les tabs
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.VISION_CONTEXT_LOADED, this.onVisionSelected ); // écouteur global sur le changement de vision

    // Ecoute des modifications depuis la vue de configuration des tabs (newtabView)
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.TAB_COLLECTION_CHANGE, this.onTabRefresh ); // écouteur global sur le changement de vision


    // this._context.events$.subscribe(() => this.onVisionSelected());
  }

  ngAfterViewInit() {
    WizEventManager.addListener(this, this.tabBar, WIZ_EVENT_TYPE.ADD, this.addNewTab);
    WizEventManager.addListener(this, this.tabBar, WIZ_EVENT_TYPE.DELETE, this.removeTab);

    WizEventManager.addListener(this, this.tabBar, WIZ_EVENT_TYPE.SELECTION_CHANGING, this.clicOnTab, {
      capture: true,
    }); // écoute sélection d'un onglet
  }

  private _onTabChanged(pTabCode: string, pCommit: boolean = true) {
    const wao: WizActionObj = this.tabs.find((v) => v.featureCode === pTabCode || v.buttonCode === pTabCode);
    this._currentTab = pTabCode;
    if (!!wao) {
      this.tabs.select([wao]);
      // TabEngine.currentTab = wao;
      ViewData.currentTab = wao;

    } else {
      // gestion du cas ou la nouvelle vue est une tab disponible mais ne fait pas partie du contexte
      const newWao: WizActionObj = Model.getInstance().tabEngine.availableTabs.find(
        (tab) => tab.featureCode === pTabCode || tab.buttonCode === pTabCode
      );
      if (
        newWao &&
        Model.getInstance().tabEngine.currentTabs.find(({ buttonCode }) => buttonCode === newWao.buttonCode) === undefined
      ) {
        let selection: WizActionObj[] = Model.getInstance().tabEngine.currentTabs.getWorkedSource();
        selection = selection.concat(newWao);
        Model.getInstance().tabEngine.updateContextTabs(selection);

        this.tabs.select([this.tabs.find((t) => t.buttonCode === newWao.buttonCode)]);
        // TabEngine.currentTab = newWao;
        ViewData.currentTab = newWao;
      } else {
        this.tabs.clearSelection();
      }
    }

    if (pCommit) {
      // this._context.saveCurrentVision({ data: {selectedTab: TabEngine.currentTab?.featureCode }});
      this._context.saveCurrentVision({ data: {selectedTab: ViewData.currentTab?.featureCode }});
    }
  }

  /** chargement des tabs du user sur origine / changement */
  private drawTabs(): void {
    const currV: BaseView = Model.getInstance().navigationEngine.getCurrentView();
    this.tabs = Model.getInstance().tabEngine.refreshTabs(!!currV && currV.code === RouteEngine.VISION_VIEW);
    // console.log('tabbar draw tabs', this.tabs);
    // Sur un changement manuel d'ordre des tabs, on update le context avec la nouvelle collection
    this.tabs.changes
      .pipe(
        filter(({ type }) => type === 'orderChanged'),
        takeUntil(this._destroyed$)
      )
      .subscribe(({ value }) => {
        let arr: WizActionObj[] = value;
        let arrMap: Map<string, WizActionObj> = new Map();
        // Fix valeurs en double...
        arr.forEach(wao => {
          arrMap.set(wao.buttonCode, wao);
          // console.log(wao.buttonCode, wao.order);
        });
        let cleanArr = [...arrMap.values()];
        cleanArr.forEach(wao => {
          // arrMap.set(wao.buttonCode, wao);
          // console.log(wao.buttonCode, wao.order, wao.viewOrder);
        });
        Model.getInstance().tabEngine.updateContextTabs(value);
      });
  }

  /**
   * Handler de click (boutons de panneaux gauche/droit)
   * @param e click
   */
  public panels(panel: string): void {
    if (panel === 'left') {
      Model.getInstance().navigationEngine.showHideLeftSidePanel();
    } else {
      Model.getInstance().navigationEngine.showHideRightSidePanel();
    }
  }

  /**
   * Demande d'ouverture du tab d'ajout de tab (clic sur +)
   * @param e evenement clic
   */
  public addNewTab() {
    // this._lastClickedTab = null; // on clear la sélection
    Model.getInstance().navigationEngine.navigate(RouteEngine.NEWTAB_VIEW);
  }

  /**
   * Clic sur un onglet
   * @param e evenement clic
   */
  public clicOnTab(e: WizEvent) {
    e.preventDefault();
    const navigationButton: WizTabButton = e.value ? (e.value.next as WizTabButton) : null;
    if (!!navigationButton) {
      this.doNavigate(navigationButton.data);
    }
  }

  /**
   * Déclenche la navigation suivant le paramétrage de l'action obj en param
   * @param tab
   */
  private doNavigate(tab: WizActionObj) {
    if (tab.kind === ViewData.KIND_DYNAMIC) {
      const tabData: TabVO = tab.data;
      Model.getInstance().navigationEngine.navigate([RouteEngine.USER_TAB_VIEW, tabData.code]);
    } else if (WizNavigationManager.getPathRoute(tab.buttonCode)) {
      Model.getInstance().navigationEngine.navigate(tab.buttonCode);
    }
  }

  /**
   * Demande de suppression de tab
   * @param e evenement clic
   */
  public removeTab(e: WizEvent) {
    // tentative de fermeture de la tab en cour d'utilisation alors qu'il y a une modif
    const currentView: BaseView = Model.getInstance().navigationEngine.getCurrentView();
    if (
      (e.value.kind === ViewData.KIND_DYNAMIC &&
        currentView instanceof UserTabView &&
        (currentView as UserTabView).currentTab.code === e.value.buttonCode) || // userTabView
      e.value.buttonCode === currentView.code
    ) {
      // autres vues
      if (ViewData.wizUpdateModel) {
        WizPopUp.confirm(
          '$.cancel.update.pop.title.$',
          '$.cancel.update.pop.content.$',
          this.confirmRemoveTab.bind(this),
          CONFIRMATION_MODE.CONFIRM_CANCEL,
          e.value
        ).show();
      } else {
        this.removeAndSelectNextTab(e.value);
      }
    } else {
      Model.getInstance().tabEngine.removeTab(e.value);
    }
  }

  private confirmRemoveTab(confirmationResult: ConfirmationResultObj): void {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      this.removeAndSelectNextTab(confirmationResult.data);
    }
  }

  /**
   * Fonction permettant la suppression de la tab en cours d'utilisation et sélection de la suivante
   * @param pTab la tab en cours d'utilisation
   */
  private removeAndSelectNextTab(pTab: WizActionObj): void {
    if (this.tabs.length === 1) {
      // on supprime le dernier...
      Model.getInstance().tabEngine.removeTab(pTab);
      Model.getInstance().navigationEngine.navigate(RouteEngine.NEWTAB_VIEW);
      return;
    }

    const currentIndex: number = this.tabs.getItemIndex(pTab);
    // par défaut on prend la tab suivante
    let nextTab: WizActionObj = this.tabs.getItem(currentIndex + 1, false);
    // pas de nextTab ? on prend la précédente
    if (!nextTab) {
      nextTab = this.tabs.getItem(currentIndex - 1, false);
    }

    Model.getInstance().tabEngine.removeTab(pTab);
    if (nextTab) {
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false)); // on force l'annulation du modelUpdate
      Model.getInstance().navigationEngine.navigate(
        nextTab.kind === ViewData.KIND_DYNAMIC
          ? [RouteEngine.USER_TAB_VIEW, nextTab.buttonCode]
          : nextTab.buttonCode
      );
    }
  }

  private onTabRefresh(e: AlkEvent): void {
    // console.log(' Tab refresh');
    this.drawTabs();
    this.tabs.refresh();
    // console.log('tabbar onVisionSelected', this.tabs)
    this._changedDetectorRef.markForCheck();
  }

  /** On réagit au changement de vision. Sur changement de vision on refiltre les tabs */
  private onVisionSelected(e: AlkEvent = null) {
    // console.log(' Tab visionSelected');
    this.drawTabs();
    this.tabs.changes
      .pipe(
        filter(({ type }) => type === 'refreshed'),
        first()
      )
      .subscribe(() => this._setSelectedTab());
    this.tabs.refresh();
    // console.log('tabbar onVisionSelected', this.tabs)
    this._changedDetectorRef.markForCheck();
  }

  /** Repositionnement et navigation sur le dernier tab actif */
  private _setSelectedTab() {
      if (this.tabs.length === 0) {
        // Pas de tabs ? on renvoie vers la new tab view
        Model.getInstance().navigationEngine.navigate(RouteEngine.NEWTAB_VIEW);
      } else {

        // console.log('tabbar _setSelectedTab', this.tabs, this._currentTab);
        let ongoingTab: WizActionObj = null;

        // on a une info de tab, pas forcément correcte
        let shouldBe: boolean = false;

        if (Model.getInstance().tabEngine.selectTabFromContext) {
          shouldBe = true;
          
          // L'onglet sélectionné doit être repris du contexte
          const visionSelectedTab: string = this._context.getVisionContext()?.data?.selectedTab;
          ongoingTab = visionSelectedTab
            ? this.tabs.find(({ featureCode }) => featureCode === visionSelectedTab)
            : this.tabs.getItem(0);
        } 

        if (ongoingTab) {
          // Force la navigation vers l'onglet
          this.doNavigate(ongoingTab);
          // Force la sélection de l'onglet dans la tabBar
          this._onTabChanged(ongoingTab.featureCode, false);
        } else {
          if(shouldBe) {
            // on devrait, mais le tab existe pas...
            Model.getInstance().navigationEngine.navigate(RouteEngine.NEWTAB_VIEW);
          }
        }

        // Dire au navigationEngine de sélectionner l'onglet du contexte (jusqu'à nouvel ordre)
        Model.getInstance().tabEngine.selectTabFromContext = true;

      }
  }

  ngOnDestroy(): void {
    this._destroyed$.next(true);
    this._destroyed$.complete();
  }

  public disableLeft(): boolean {
    if (
      !!Model.getInstance().navigationEngine.getCurrentView() &&
      !!Model.getInstance().navigationEngine.getCurrentView().leftSideContent()
    ) {
      return false;
    }
    return true;
  }

  public disableRight(): boolean {
    if (
      !!Model.getInstance().navigationEngine.getCurrentView() &&
      !!Model.getInstance().navigationEngine.getCurrentView().rightSideContent()
    ) {
      return false;
    }
    return true;
  }
}
